import { render } from "./ProfileForm.vue?vue&type=template&id=452d7ed0&bindings={}"
import script from "./ProfileForm.vue?vue&type=script&lang=ts"
export * from "./ProfileForm.vue?vue&type=script&lang=ts"
script.render = render

export default script